import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentSection: 'home',
  isMenuOpen: false,
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setCurrentSection: (state, action) => {
      state.currentSection = action.payload;
    },
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen;
    },
    closeMenu: (state) => {
      state.isMenuOpen = false;
    },
  },
});

export const { setCurrentSection, toggleMenu, closeMenu } = navigationSlice.actions;
export default navigationSlice.reducer;
